'use client';

import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { store } from '@store/store';

/**
 * This component will only be rendered once per request on the server,
 * but might be re-rendered multiple times on the client if there are stateful client components located above this component in the tree,
 * or if this component also contains other mutable state that causes a re-render.
 */
export const StoreProvider = ({ children }: { children: ReactNode }) => (
  // const storeRef = useRef<typeof store>();
  // if (!storeRef.current) {
  //   // Create the store instance the first time this renders
  //   storeRef.current = makeStore();
  // }

  <Provider store={store}>{children}</Provider>
);

